import { Button } from 'baby-design'
import { shopRegistryPath, storePath } from 'lib/urls'
import classNames from 'classnames'
import css from './Button.styles.scss'

interface ButtonContainerProps {
  children: React.ReactNode
}

const ButtonContainer = ({ children }: ButtonContainerProps) => (
  <div className={css.Button__container}>{children}</div>
)

export const ShopYourRegistryButton = () => (
  <ButtonContainer>
    <Button
      className={classNames(css.Button, [css[`Button--wide`]])}
      href={shopRegistryPath}
      size="lg"
      variant="primary"
    >
      Shop your registry
    </Button>
  </ButtonContainer>
)

export const BrowseShopButton = () => (
  <ButtonContainer>
    <Button
      className={classNames(css.Button, [css[`Button--wide`]])}
      href={storePath}
      size="lg"
      variant="secondary"
    >
      Browse Babylist Shop
    </Button>
  </ButtonContainer>
)

export const AddItemFromShopButton = () => (
  <ButtonContainer>
    <Button
      className={classNames(css.Button, [css[`Button--wide`]])}
      href={storePath}
      size="lg"
      variant="primary"
    >
      Add items from Babylist Shop
    </Button>
  </ButtonContainer>
)
